import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitoshirdicab() {



  const cardData = {
    keyword: " Mumbai to Shirdi Cab ",

headingDescription: "Royal Route Cab offers reliable and comfortable Mumbai to Shirdi cab services, ensuring a safe, smooth, and peaceful journey for devotees and travelers. Whether you are planning a pilgrimage, family trip, group travel, or weekend darshan visit, our professional drivers and well-maintained vehicles provide a stress-free travel experience. The Mumbai to Shirdi route covers approximately 230 to 250 km and takes around 4 to 5 hours depending on traffic conditions. We offer flexible booking options including one-way trips, round trips, and customized travel packages with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, and premium vehicles suitable for individuals, families, and groups. With easy online booking and 24/7 customer support, Royal Route Cab is your trusted partner for Mumbai to Shirdi travel.",

topPlaces: [
  {
    title: "Shri Sai Baba Samadhi Mandir",
    description: "Shri Sai Baba Samadhi Mandir is the most sacred place in Shirdi, dedicated to Sai Baba. Devotees from all over the world visit this temple to seek blessings and experience spiritual peace."
  },
  {
    title: "Dwarkamai Mosque",
    description: "Dwarkamai Mosque is where Sai Baba spent a large part of his life. It is a deeply spiritual place where devotees can feel the presence and teachings of Sai Baba."
  },
  {
    title: "Shani Shingnapur",
    description: "Shani Shingnapur is a famous temple village known for Lord Shani Dev. It is a popular pilgrimage spot often combined with Shirdi trips."
  },
  {
    title: "Sai Heritage Village",
    description: "Sai Heritage Village is a theme park that showcases the life and teachings of Sai Baba through cultural representations and exhibits."
  },
  {
    title: "Chavadi",
    description: "Chavadi is a historic place where Sai Baba used to sleep on alternate nights. It holds great religious importance for devotees."
  },
  {
    title: "Lendi Baug",
    description: "Lendi Baug is a peaceful garden area maintained by Sai Baba himself. It is known for its calm environment and spiritual significance."
  },
  {
    title: "Wet N Joy Water Park",
    description: "Wet N Joy Water Park is a popular recreational spot near Shirdi offering water rides and entertainment for families and tourists."
  },
  {
    title: "Khandoba Temple",
    description: "Khandoba Temple is an important temple in Shirdi where Sai Baba was first recognized as a saint. It holds historical and spiritual value."
  },
  {
    title: "Maruti Mandir",
    description: "Maruti Mandir is a peaceful temple dedicated to Lord Hanuman, located near Shirdi and visited by devotees for blessings and strength."
  },
  {
    title: "Sai Teerth Theme Park",
    description: "Sai Teerth Theme Park is India’s first devotional theme park dedicated to Sai Baba, offering an immersive spiritual experience through rides and exhibits."
  }
],

whychoose: [
  {
    WhyChooseheading: "Comfortable Pilgrimage Travel",
    WhyChoosedescription: "Royal Route Cab offers smooth and comfortable Mumbai to Shirdi cab services, ideal for devotees, families, and group pilgrimage trips."
  },
  {
    WhyChooseheading: "Experienced Drivers",
    WhyChoosedescription: "Our drivers are experienced in long-distance routes and ensure safe and peaceful travel to Shirdi."
  },
  {
    WhyChooseheading: "Transparent Pricing",
    WhyChoosedescription: "We provide clear and upfront pricing with no hidden charges, including tolls and driver allowance."
  },
  {
    WhyChooseheading: "24/7 Availability",
    WhyChoosedescription: "Our Mumbai to Shirdi cab service is available 24/7 for early morning darshan or late-night travel."
  },
  {
    WhyChooseheading: "Clean & Comfortable Vehicles",
    WhyChoosedescription: "All vehicles are well-maintained, sanitized, and air-conditioned for a comfortable journey."
  },
  {
    WhyChooseheading: "Flexible Booking Options",
    WhyChoosedescription: "We offer one-way, round-trip, and customized Shirdi travel packages as per your requirements."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from sedans, SUVs like Ertiga and Innova, Innova Crysta, luxury cars, and Tempo Travellers for group travel."
  },
  {
    WhyChooseheading: "Trusted Pilgrimage Service",
    WhyChoosedescription: "Royal Route Cab is trusted by thousands of devotees for safe and comfortable Mumbai to Shirdi journeys."
  }
],

faqData: [
  {
    question: "Do you provide Mumbai to Shirdi cab service?",
    answer: "Yes, Royal Route Cab provides reliable cab services from Mumbai to Shirdi for one-way and round trips."
  },
  {
    question: "How far is Shirdi from Mumbai?",
    answer: "The distance is approximately 230 to 250 km and takes around 4 to 5 hours depending on traffic."
  },
  {
    question: "Is cab service available 24/7?",
    answer: "Yes, our Mumbai to Shirdi cab service is available 24/7."
  },
  {
    question: "Can I book a same-day return cab?",
    answer: "Yes, we offer both same-day return and overnight Shirdi packages."
  },
  {
    question: "Do you provide doorstep pickup?",
    answer: "Yes, we provide pickup from home, hotel, or office anywhere in Mumbai."
  },
  {
    question: "Are vehicles air-conditioned?",
    answer: "Yes, all vehicles are fully air-conditioned for comfortable travel."
  },
  {
    question: "Can I book online?",
    answer: "Yes, you can easily book Mumbai to Shirdi cab online or via phone."
  },
  {
    question: "Is advance booking required?",
    answer: "Advance booking is recommended, especially during weekends and festival seasons."
  },
  {
    question: "Are vehicles sanitized?",
    answer: "Yes, all vehicles are regularly cleaned and sanitized for passenger safety."
  },
  {
    question: "Which vehicles are available?",
    answer: "We provide sedans, SUVs like Innova and Ertiga, Innova Crysta, luxury cars, and Tempo Travellers."
  }
],

testimonials: [
  {
    id: 1,
    name: "Mr. Ramesh Patil",
    feedback: "Very smooth and peaceful journey to Shirdi. Driver was polite and service was excellent.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita Sharma",
    feedback: "Great experience for our Shirdi darshan trip. Clean car and timely pickup.",
    rating: 5
  }
],





services: [
  {
    name: "Mumbai to Shirdi Cab",
    description: "Mumbai to Shirdi cab service offers a comfortable and reliable journey for devotees traveling to the sacred Sai Baba temple. This route is popular for religious trips, family visits, and group travel. Professional drivers ensure safe driving on highways and timely arrival. Customers can choose from sedan, SUV, and luxury vehicles based on their needs. Flexible pickup options across Mumbai add convenience. It ensures a peaceful and hassle-free pilgrimage journey."
  },
  {
    name: "Mumbai to Shirdi Taxi",
    description: "Mumbai to Shirdi taxi provides convenient and private travel for devotees and tourists visiting Shirdi. With door-to-door pickup and drop, this service ensures maximum comfort. Vehicles are clean and well-maintained for long-distance travel. Experienced drivers ensure safe and smooth journeys. It is suitable for families, elderly travelers, and groups. It guarantees a reliable travel experience."
  },
  {
    name: "Mumbai to Shirdi Taxi Fare",
    description: "Mumbai to Shirdi taxi fare is designed to be transparent and affordable for all travelers. Pricing depends on vehicle type, trip duration, and travel preferences. Customers receive clear fare details including tolls and driver allowance where applicable. Budget and premium options are available. It helps in easy travel planning. It ensures value for money."
  },
  {
    name: "Mumbai to Shirdi Car Rental",
    description: "Mumbai to Shirdi car rental offers flexible travel solutions for individuals and families planning a comfortable journey. Customers can choose from a variety of vehicles including sedan, SUV, and luxury cars. This service is ideal for one-way and round trips. Easy booking process and transparent pricing make it convenient. It ensures a smooth and enjoyable journey."
  },
  {
    name: "Mumbai to Shirdi Taxi Service",
    description: "Mumbai to Shirdi taxi service provides reliable long-distance transportation with a focus on safety and comfort. This service is ideal for pilgrims and tourists visiting Shirdi. Vehicles are well-maintained and driven by experienced chauffeurs. Flexible travel timings and routes add convenience. It ensures a stress-free journey."
  },
  {
    name: "Mumbai to Shirdi Cabs Round Trip",
    description: "Mumbai to Shirdi cabs round trip service is perfect for travelers planning a return journey after darshan. This package includes pickup, drop, waiting time, and return travel. Flexible schedules allow comfortable temple visits. Multiple vehicle options are available for families and groups. Professional drivers ensure timely service. It offers convenience and cost efficiency."
  },
  {
    name: "Mumbai to Shirdi Taxi Innova Fare",
    description: "Mumbai to Shirdi taxi Innova fare is suitable for families and groups seeking spacious and comfortable travel. The Innova offers ample seating and luggage space for long journeys. Pricing is transparent and competitive. It is ideal for group pilgrimages and family trips. It ensures a premium and comfortable experience."
  },
  {
    name: "Mumbai to Shirdi Cab Service",
    description: "Mumbai to Shirdi cab service ensures a smooth and reliable journey for devotees and travelers. Vehicles are regularly maintained for long-distance performance. Professional drivers ensure safe travel on highways. Flexible pickup and drop options add convenience. It is suitable for personal and group travel. It guarantees a comfortable journey."
  },
  {
    name: "Mumbai to Shirdi Taxi Cost",
    description: "Mumbai to Shirdi taxi cost varies based on vehicle type, travel duration, and trip type. Transparent pricing helps travelers plan their journey efficiently. Affordable options are available for sedan, SUV, and luxury vehicles. No hidden charges ensure trust. It provides cost-effective travel solutions."
  },
  {
    name: "Mumbai Airport to Shirdi Taxi",
    description: "Mumbai airport to Shirdi taxi service offers direct pickup from the airport for travelers heading to Shirdi. This service is ideal for outstation passengers arriving in Mumbai. Timely pickups and comfortable vehicles ensure a smooth journey. Drivers are experienced in long-distance routes. It ensures a seamless airport transfer."
  },
  {
    name: "Mumbai Airport to Shirdi Taxi Fare",
    description: "Mumbai airport to Shirdi taxi fare is designed for transparency and convenience. Pricing includes distance, tolls, and driver charges where applicable. Customers receive clear cost breakdown before booking. Multiple vehicle options suit different budgets. It helps in planning travel expenses easily."
  },
  {
    name: "Mumbai to Shirdi Taxi Price",
    description: "Mumbai to Shirdi taxi price depends on car type, travel plan, and trip duration. Customers can choose budget-friendly or premium vehicles based on their preference. Transparent pricing ensures no hidden costs. It helps travelers select the best option. It ensures value-driven travel."
  },
  {
    name: "Mumbai to Shirdi Taxi One Way",
    description: "Mumbai to Shirdi taxi one way is a cost-effective option for travelers needing a single-side drop. This service avoids return charges and is ideal for extended stays. Flexible pickup timings and comfortable vehicles enhance convenience. Professional drivers ensure safe travel. It is perfect for budget travel."
  },
  {
    name: "Mumbai to Shirdi by Car Fare",
    description: "Mumbai to Shirdi by car fare offers flexible pricing for private road trips. Travelers can enjoy personalized journeys with optional stops along the route. Fare depends on car type and travel plan. Transparent pricing ensures clarity. It is ideal for comfortable and private travel."
  },
  {
    name: "Mumbai to Shirdi Cab Fare",
    description: "Mumbai to Shirdi cab fare is structured to provide affordable and transparent pricing. Customers can choose from various vehicle categories. Pricing includes essential charges with no hidden costs. It helps in planning budget-friendly trips. It ensures a smooth travel experience."
  },
  {
    name: "Mumbai to Shirdi by Car",
    description: "Mumbai to Shirdi by car is one of the most comfortable ways to travel for darshan. Travelers can enjoy a relaxed journey with flexible stops. Private vehicles ensure convenience and privacy. Suitable for families and elderly travelers. It provides a peaceful travel experience."
  },
  {
    name: "Mumbai to Shirdi Cab Price",
    description: "Mumbai to Shirdi cab price varies based on vehicle type, travel duration, and trip plan. Budget and premium options are available for all travelers. Transparent pricing ensures no hidden charges. It helps customers choose suitable travel options. It ensures reliable service."
  },
  {
    name: "Mumbai Airport to Shirdi by Car",
    description: "Mumbai airport to Shirdi by car provides direct and comfortable transfer for arriving passengers. This service ensures quick pickup and smooth highway travel. Suitable for tourists and pilgrims. Vehicles are clean and well-maintained. It ensures a hassle-free journey."
  },
  {
    name: "Mumbai Shirdi Car Rental",
    description: "Mumbai Shirdi car rental offers flexible travel solutions with a wide range of vehicles. Customers can rent cars for one-way or round trips. This service is ideal for families, groups, and corporate travel. Easy booking and transparent pricing enhance convenience. It ensures a comfortable journey."
  },
  {
    name: "Mumbai to Shirdi Cab Booking",
    description: "Mumbai to Shirdi cab booking allows travelers to reserve their ride quickly and easily. Customers can choose vehicle type, pickup location, and travel date. Instant confirmation and transparent pricing ensure a smooth process. It simplifies travel planning."
  },
  {
    name: "Mumbai to Shirdi Cab Booking Online",
    description: "Mumbai to Shirdi cab booking online provides a quick and convenient way to reserve your travel. Secure payment options and instant confirmations make it user-friendly. Customers can book anytime from anywhere. It ensures availability during peak seasons."
  },
  {
    name: "Mumbai to Shirdi Cab Booking Price",
    description: "Mumbai to Shirdi cab booking price depends on car type and travel requirements. Transparent pricing ensures clarity for customers. Budget-friendly and premium options are available. It helps travelers choose the best option."
  },
  {
    name: "Mumbai to Shirdi Car Booking",
    description: "Mumbai to Shirdi car booking offers easy and flexible reservation options for travelers. Customers can select vehicle type and travel schedule. Instant confirmation ensures peace of mind. It is ideal for convenient travel planning."
  },
  {
    name: "Mumbai to Shirdi Car Hire",
    description: "Mumbai to Shirdi car hire service provides personalized travel with flexible routes and stops. Suitable for family trips and pilgrimages. Clean vehicles and professional drivers ensure comfort. It offers a relaxed journey experience."
  },
  {
    name: "Mumbai to Shirdi Car Package",
    description: "Mumbai to Shirdi car package includes complete travel solutions with pickup, drop, and optional waiting time. Ideal for temple visits and return trips. Packages are designed for convenience and affordability. It ensures a well-planned journey."
  },
  {
    name: "Mumbai to Shirdi Car Rental Price",
    description: "Mumbai to Shirdi car rental price varies based on vehicle type and package selection. Customers receive transparent pricing with no hidden costs. Options are available for all budgets. It helps in easy travel planning."
  },
  {
    name: "Mumbai to Shirdi Innova Fare",
    description: "Mumbai to Shirdi Innova fare is ideal for group travel with spacious seating and comfort. The vehicle ensures a smooth ride for long-distance journeys. Transparent pricing makes it a popular choice. It offers a premium travel experience."
  },
  {
    name: "Mumbai to Shirdi Return Cab Fare",
    description: "Mumbai to Shirdi return cab fare is suitable for travelers planning a round trip. Pricing includes pickup, drop, and return journey. Flexible schedules make it convenient for darshan trips. It ensures cost efficiency and comfort."
  },
  {
    name: "Mumbai to Shirdi Taxi Charges",
    description: "Mumbai to Shirdi taxi charges are competitive and transparent for all travelers. Charges include distance, tolls, and driver allowance. Customers receive full pricing details before booking. It ensures trust and reliability."
  },
  {
    name: "Mumbai to Shirdi Round Trip Taxi Fare",
    description: "Mumbai to Shirdi round trip taxi fare provides a complete travel solution with return journey included. Ideal for family and group travel. Flexible travel plans ensure convenience. It offers affordable and comfortable travel."
  },
  {
    name: "Mumbai to Shirdi Taxi Travel Time",
    description: "Mumbai to Shirdi taxi travel time usually ranges between 5 to 7 hours depending on traffic and route. Comfortable vehicles and experienced drivers ensure a smooth journey. Travelers can plan their schedule accordingly. It ensures timely arrival."
  },
  {
    name: "Taxi from Mumbai Airport to Shirdi",
    description: "Taxi from Mumbai airport to Shirdi offers direct and convenient travel for arriving passengers. This service ensures quick pickup and safe highway travel. Suitable for tourists and pilgrims. It guarantees a smooth and reliable journey."
  },
  {
    name: "Taxi Service from Mumbai to Shirdi",
    description: "Taxi service from Mumbai to Shirdi provides dependable long-distance transportation for all types of travelers. Professional drivers and well-maintained vehicles ensure comfort and safety. Flexible travel options enhance convenience. It guarantees a stress-free journey."
  }
],

tableData: [
  ["Mumbai to Shirdi Cab", "Mumbai to Shirdi Taxi"],
  ["Mumbai to Shirdi Taxi Fare", "Mumbai to Shirdi Car Rental"],
  ["Mumbai to Shirdi Taxi Service", "Mumbai to Shirdi Cabs Round Trip"],
  ["Mumbai to Shirdi Taxi Innova Fare", "Mumbai to Shirdi Cab Service"],
  ["Mumbai to Shirdi Taxi Cost", "Mumbai Airport to Shirdi Taxi"],
  ["Mumbai Airport to Shirdi Taxi Fare", "Mumbai to Shirdi Taxi Price"],
  ["Mumbai to Shirdi Taxi One Way", "Mumbai to Shirdi by Car Fare"],
  ["Mumbai to Shirdi Cab Fare", "Mumbai to Shirdi by Car"],
  ["Mumbai to Shirdi Cab Price", "Mumbai Airport to Shirdi by Car"],
  ["Mumbai Shirdi Car Rental", "Mumbai to Shirdi Cab Booking"],
  ["Mumbai to Shirdi Cab Booking Online", "Mumbai to Shirdi Cab Booking Price"],
  ["Mumbai to Shirdi Car Booking", "Mumbai to Shirdi Car Hire"],
  ["Mumbai to Shirdi Car Package", "Mumbai to Shirdi Car Rental Price"],
  ["Mumbai to Shirdi Innova Fare", "Mumbai to Shirdi Return Cab Fare"],
  ["Mumbai to Shirdi Taxi Charges", "Mumbai to Shirdi Round Trip Taxi Fare"],
  ["Mumbai to Shirdi Taxi Travel Time", "Taxi from Mumbai Airport to Shirdi"],
  ["Taxi Service from Mumbai to Shirdi", "Mumbai to Shirdi Cab"]
],


whychoose: [
  {
    WhyChooseheading: "Comfortable Mumbai to Shirdi Travel",
    WhyChoosedescription: "Royal Route Cabs offers a smooth and peaceful Mumbai to Shirdi cab service, ideal for devotees, families, and group pilgrimages."
  },
  {
    WhyChooseheading: "Experienced Drivers for Highway Routes",
    WhyChoosedescription: "Our drivers are skilled in Mumbai to Shirdi routes, ensuring safe driving, proper navigation, and timely arrival for darshan."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear and upfront pricing including tolls, driver allowance, and all travel costs without any hidden fees."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Mumbai to Shirdi cab service is available 24/7, allowing flexible travel for early morning or overnight darshan trips."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well-maintained, and regularly cleaned to ensure a comfortable long-distance journey."
  },
  {
    WhyChooseheading: "One Way & Round Trip Options",
    WhyChoosedescription: "Choose from one-way cab service, round-trip bookings, or same-day return packages for Shirdi darshan."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "We offer sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers for families and group travel."
  },
  {
    WhyChooseheading: "Trusted Pilgrimage Travel Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by devotees for Mumbai to Shirdi cab bookings due to punctual service, safe travel, and reliable drivers."
  }
]

};

const faqData = [
  { question: "Do you provide Mumbai to Shirdi cab service?", answer: "Yes, Royal Route Cabs offers reliable cab services from Mumbai to Shirdi for both one-way and round trips." },
  { question: "What is the distance between Mumbai and Shirdi?", answer: "The distance is approximately 240 to 260 km and takes around 5 to 6 hours depending on traffic." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Mumbai to Shirdi cab service operates 24/7." },
  { question: "Which vehicles are available for this route?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, and Tempo Travellers." },
  { question: "Can I book a one-way cab?", answer: "Yes, we provide both one-way and round-trip cab services." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable travel." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we offer pickup from home, hotel, and airport anywhere in Mumbai." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended, especially during weekends and festive seasons." },
  { question: "Do you provide same-day return for Shirdi?", answer: "Yes, we offer same-day return packages for Shirdi darshan." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Anil Deshmukh",
    feedback: "Traveling from Mumbai to Shirdi with Royal Route Cabs was a peaceful experience. The ride was smooth, and we reached comfortably without any hassle.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Patil",
    feedback: "Very reliable service for our Mumbai to Shirdi trip. The cab was clean, and the driver ensured a safe and comfortable journey throughout.",
    rating: 5
  }
];
























  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Shirdi Cab",
  "image": "https://www.royalroutecabs.com/assets/images/mumbai-to-shirdi-cab.jpg", // replace if needed
  "description": "Book Mumbai to Shirdi cab with Royal Route Cabs for a comfortable and affordable यात्रा. Choose from sedan, SUV, Innova, and luxury cars for one-way and round-trip trips. 24x7 taxi service with professional drivers ensures a safe and smooth journey.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2800", // adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/mumbai-to-shirdi-cab"
  }
};




  return (
    <div>
<Helmet>
  <title>Mumbai to Shirdi Cab | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Mumbai to Shirdi cab at best price with Royal Route Cabs. One-way & round-trip taxi service with sedan, SUV, Innova & luxury cars. Safe, reliable & 24x7 available."
  />

  <meta
    name="keywords"
    content="mumbai to shirdi cab, mumbai to shirdi taxi, mumbai to shirdi taxi fare, mumbai to shirdi car rental, mumbai to shirdi taxi service, mumbai to shirdi cabs round trip, mumbai to shirdi taxi innova fare, mumbai to shirdi cab service, mumbai to shirdi taxi cost, mumbai airport to shirdi taxi, mumbai airport to shirdi taxi fare, mumbai to shirdi taxi price, mumbai to shirdi taxi one way, mumbai to shirdi by car fare, mumbai to shirdi cab fare, mumbai to shirdi by car, mumbai to shirdi cab price, mumbai airport to shirdi by car, mumbai shirdi car rental, mumbai to shirdi cab booking, mumbai to shirdi cab booking online, mumbai to shirdi cab booking price, mumbai to shirdi car booking, mumbai to shirdi car hire"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/4.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitoshirdicab;